import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useHistory } from 'react-router'
import { useTranslation } from 'react-i18next'
import { EidButton, WarningModal } from 'packages/eid-ui'
import { Icon } from 'packages/eid-icons'
import { Button } from 'components'
import { useQuery } from 'packages/core'
import { useDeleteManagementRole } from 'hooks'

const DeleteAppManagementRole = ({ item, drawerView, ...rest }) => {
    const { t } = useTranslation()
    const [showConfirm, setShowConfirm] = useState(false)

    const query = useQuery()
    const history = useHistory()
    const [deleteRole, { isLoading: isDeleting }] = useDeleteManagementRole()

    const handleDelete = () => {
        deleteRole(item.id).then(() => {
            setShowConfirm(false)
            query.delete('appManagementRoleId')
            history.push(`${history.location.pathname}?${query.toString()}`)
        })
    }

    return (
        <>
            {!drawerView ? (
                <Button.Delete
                    item={item}
                    onClick={() => setShowConfirm(true)}
                    disabled={item.isExpired}
                    {...rest}
                />
            ) : (
                <Box width="150px" marginLeft={'40px'}>
                    <EidButton.DrawerActionButton
                        disabled={item.isExpired}
                        fontColor="#ffffff"
                        bgColor="#E40000"
                        width="100%"
                        onClick={() => setShowConfirm(true)}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            height={'12px'}
                            width={'12px'}
                        >
                            <Icon
                                name="DeleteX"
                                fill="#ffffff"
                                color="#ffffff"
                            />
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            marginLeft="10px"
                        >
                            <Typography style={{ color: '#ffffff' }}>
                                {t('Delete')}
                            </Typography>
                        </Box>
                    </EidButton.DrawerActionButton>
                </Box>
            )}
            <WarningModal
                title={`${t('Delete')} ${item?.friendlyName}`}
                description={t('AppManagementRoleDeleteMessage')}
                yesLabel={t('Delete')}
                noLabel={t('Cancel')}
                open={showConfirm}
                cancel={() => setShowConfirm(false)}
                proceeding={isDeleting}
                proceed={handleDelete}
            />
        </>
    )
}

DeleteAppManagementRole.defaultProps = {
    drawerView: false,
}
export default DeleteAppManagementRole
